import React, { useEffect, useState, useRef } from 'react';
import {
  Header_2026, Footer_2026, DetalleBlog_Header_2026, DetalleBlog_Contenido_2026
  , DetalleBlog_ComentariosResponse_2026, DetalleBlog_Relacionados_2026
} from '../container';
import '../App.css';
import { useLocation } from 'react-router-dom';
import { useAxios } from '../hooks/useAxios';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAxios3 } from "../hooks/useAxios";
import axios from "axios";

const DetalleGuid = () => {
  const location = useLocation();
  const [t, i18n] = useTranslation("global");
  const [t2] = useTranslation("global");
  const [t3] = useTranslation("detail_blog");
  const searchParams = new URLSearchParams(location.search);
  let myParam = searchParams.get('GUID');
// Si no encuentra el parámetro con la clave 'GUID', intenta buscarlo con 'guid'
  if (!myParam) {
      myParam = searchParams.get('guid');
  }
  if (myParam) {
      // El valor del parámetro se obtuvo correctamente, continuar con el código aquí
  } else {
      // El parámetro no se proporcionó en la URL
  }

  //const [t, i18n] = useTranslation("global");
  //const { data, isLoading, error } = useAxios(`/blogs/by-guid/${ myParam }?lang=${ i18n.language }`);
  // const { data, isLoading, error } = useAxios(`/blogs/by-friendly/${ friendly }?lang=en`);
  //const { titulo, categorias, fecha, resumen, contenidoHtml, blogsRelacionados, comentarios, tag, urlImagen, guid } = !!data && data;
  const { data, isLoading, error } = useAxios(
    `/blogs/by-guid/${myParam}?lang=${i18n.language}`
  );
  
  const {
    titulo,
    categorias,
    fecha,
    resumen,
    contenidoHtml,
    blogsRelacionados,
    comentarios,
    tag,
    urlImagen,
    guid
  } = data || {};
  
  const rankingUrl = tag
    ? `blogs/ranking/${tag}`
    : null;
  
  const {
    data2,
    isLoading2,
    error2
  } = useAxios3(rankingUrl);
  //const { data, isLoading, error } = useAxios(`/blogs/by-guid/${ friendly }?lang=${ i18n.language }`);
  //const { titulo, categorias, fecha, resumen, contenidoHtml, blogsRelacionados, comentarios, tag, urlImagen, guid } = !!data && data;
  const [votos, setVotos] = useState([]);
  //const [url2, setUrl2] = useState(`blogs/ranking/` + tag);
  //const { data2, isLoading2, error2 } = useAxios3(url2);
  const [comentariosAll, setComentariosAll] = useState([]);

  useEffect(() => {
    if (data2) {
      setVotos(data2);
    }
  }, [data2]);

  useEffect(() => {
    const fetchComentarios = async () => {
      try {
        const response = await axios.get(`https://www.ricardosalinas.com/S8JFmpfeLW5iUVROXz2owTPU/api/comments/byfriendlyresponse/${tag}?offset=0&limit=1000`);
        setComentariosAll(response.data);
      } catch (error) {
        console.error("Error fetching comentarios: ", error);
      }
    };

    fetchComentarios();
  }, [tag]);

  console.log(error);
  return (
    <>
      <Header_2026 />
      <div id='top-entrada' class="_nghost-ng-c1842723448">
        <section aria-labelledby="blog-detail-title" class="blog-detail-page">
          <article class="blog-detail-page__article">
            <a
              class="blog-detail-page__back-link blog-detail-page__back-link--top"
              href={"/" + i18n.language + "/Ideas-en-libertad"}>{t3("2026.back")}</a>

            <DetalleBlog_Header_2026 loading={isLoading} titulo={titulo} urlImagen={urlImagen} fecha={fecha} resumen={resumen} ranking={votos.ranking} comentarios={comentariosAll.length} contenidoHtml={contenidoHtml} />
            <DetalleBlog_Contenido_2026 loading={isLoading} categorias={categorias} contenidoHtml={contenidoHtml} />

          </article>
          <DetalleBlog_ComentariosResponse_2026 ranking={votos.ranking} comentarios={comentariosAll} votos={votos.votes} friendlyTag={tag} guid={guid} titulo={titulo} />

          <div class="_ngcontent-ng-c1842723448 _nghost-ng-c2335900281">
            <section aria-label="Suscripción al boletín"
              class="blog-detail-newsletter-cta">
              <div class="blog-detail-newsletter-cta__container">
                <p class="blog-detail-newsletter-cta__message"><span
                  class="blog-detail-newsletter-cta__message-desktop">{(t2('general.suscribirsel'))}</span><span
                    class="blog-detail-newsletter-cta__message-mobile">{(t2('general.suscribirsel2'))}</span></p>
                <button type="button" class="blog-detail-newsletter-cta__button"><span
                  class="blog-detail-newsletter-cta__button-desktop">{(t2('general.suscribirsebtn'))}</span><span
                    class="blog-detail-newsletter-cta__button-mobile">{(t2('general.suscribirsebtn2'))}</span></button>
              </div>
            </section>
          </div>
          <DetalleBlog_Relacionados_2026 blogsRelacionados={blogsRelacionados} categorias={categorias} />

          
        </section>
      </div>
      <Footer_2026 />
    </>
  )
}

export default DetalleGuid
